export default __webpack_public_path__ + "static/media/fren-train.f8fbaa2e.jpeg";